import { render, staticRenderFns } from "./OlympicDiffsModal.vue?vue&type=template&id=4a5f591c&"
import script from "./OlympicDiffsModal.vue?vue&type=script&lang=js&"
export * from "./OlympicDiffsModal.vue?vue&type=script&lang=js&"
import style0 from "./OlympicDiffsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports